
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom';
import App from './App';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from "react-redux";
import reducer from './compoments/Redux/combine';
import thunkMiddleware from 'redux-thunk';
const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware))
  const store = createStore(reducer, composedEnhancer)
ReactDOM.render(
  <React.StrictMode>
  <Provider store={store}>
      <App />
  </Provider>
  </React.StrictMode>
  ,
  document.getElementById('root')
);